import { render, staticRenderFns } from "./MyStats.vue?vue&type=template&id=7d913840&scoped=true"
import script from "./MyStats.vue?vue&type=script&lang=js"
export * from "./MyStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d913840",
  null
  
)

export default component.exports